<template>
    <div class="gray-back" style="padding:.2rem 0 1rem 0">
        <van-form
                  @submit="onSubmit"
                  @failed="onFailed"
        >
        <van-cell-group>
            <van-field
                    v-model="formData.name"
                    :rules="[{ required: true, message: '单位名称不能为空' }]"
                    label="单位名称"
                    input-align="right"
                    error-message-align="right"
                    clearable
                    placeholder="请输入单位名称"
            />
            <van-field name="radio" label="类型"
                       input-align="right">
                <template #input>
                    <van-radio-group v-model="formData.type" direction="horizontal">
                        <van-radio checked-color="#ffb01b" :name="1">幼儿园</van-radio>
                        <van-radio checked-color="#ffb01b" :name="2">小学</van-radio>
                        <van-radio checked-color="#ffb01b" :name="3">中学</van-radio>
                        <van-radio checked-color="#ffb01b" :name="4">大学</van-radio>
                        <van-radio checked-color="#ffb01b" :name="5">其他</van-radio>
                    </van-radio-group>
                </template>
            </van-field>


            <van-field
                    readonly
                    clickable
                    name="area"
                    :value="formData.ncounty?formData.nprovince+'/'+formData.ncity+'/'+formData.ncounty:''"
                    input-align="right"
                    label="省市"
                    placeholder="点击选择省市区"
                    @click="showNamekey = true"
            />
            <van-popup v-model="showNamekey" position="bottom">
                <van-area
                        :area-list="namekeyList"
                        :value="formData.namekey"
                        @confirm="onNamekeyConfirm"
                        @cancel="showArea = false"
                />
            </van-popup>

            <van-field
                    readonly
                    clickable
                    name="area"
                    :value="formData.county?formData.province+'/'+formData.city+'/'+formData.county:''"
                    input-align="right"
                    label="地区选择"
                    placeholder="点击选择省市区"
                    @click="showArea = true"
            />
            <van-popup v-model="showArea" position="bottom">
                <van-area
                        :area-list="areaList"
                        :value="formData.area"
                        @confirm="onAreaConfirm"
                        @cancel="showArea = false"
                />
            </van-popup>


            <van-field
                    v-model="formData.address"
                    :rules="[{ required: true, message: '请输入详细地址' }]"
                    error-message-align="right"
                    label="详细地址"
                    input-align="right"
                    clearable
                    placeholder="请输入详细地址"
            />

        </van-cell-group>

        <van-divider>联系人信息</van-divider>

        <van-cell-group>
            <van-field
                    v-model="formData.nickname"
                    :rules="[{ required: true, message: '请输入姓名' }]"
                    error-message-align="right"
                    label="姓名"
                    input-align="right"
                    clearable
                    placeholder="请输入姓名"
            />

            <van-field
                    v-model="formData.certificatenumber"
                    :rules="[{ validator: validator.idCard,message:'请输入正确的身份证号'}]"
                    error-message-align="right"
                    label="身份证号"
                    input-align="right"
                    clearable
                    placeholder="请输入身份证号"
            />



            <van-cell title="身份证照片" :value="formData.certificatepic.length+'/2'">
                <template slot="icon" >
                    <van-icon class="question-icon" name="question-o" @click="onQuestion('zhizhaopic')"/>
                </template>
            </van-cell>

            <div class="row">
                <PicUploader :fileList="formData.certificatepic" :limit="2"
                             :name="'certificatepic'"></PicUploader>
            </div>
            <div class="operate-desc-left">上传身份证号码正反面</div>


            <van-field
                    v-model="formData.email"
                    :rules="[{ validator: validator.email,message:'请输入正确的邮箱'} ]"
                    error-message-align="right"
                    label="邮箱"
                    input-align="right"
                    clearable
                    placeholder="请输入邮箱"
            />


            <van-field
                    v-model="formData.phone"
                    :rules="[{ validator: validator.phone,message:'请输入正确的手机号'}]"
                    error-message-align="right"
                    label="手机"
                    input-align="right"
                    clearable
                    placeholder="请输入手机"
            />

                        <van-field
                                v-model="formData.phonecode"
                                label="验证码"
                                :rules="[{ required: true,message:'请输入验证码'}]"
                                error-message-align="right"
                                input-align="right"
                                clearable
                                placeholder="请输入验证码"
                        >
                        <template #button>
                        <van-button @click="getCode" native-type="button" size="small" type="primary" :disabled="clockSecond>0">{{clockSecond>0?
                    '('+clockSecond+'s)':'获取验证码'}}</van-button>
                        </template>
                        </van-field>
            <van-field
                    v-model="formData.qq"
                    label="QQ"
                    input-align="right"
                    clearable
                    placeholder="请输入QQ"
            />

            <van-field
                    v-model="formData.weixin"
                    label="微信号"
                    input-align="right"
                    clearable
                    placeholder="请输入微信号"
            />

        </van-cell-group>

        <div class="savebtn" v-show="formData.registstatus==0||formData.registstatus==3">
            <van-button
                    color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                    style="width: 3rem"
                    size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">提交备案</van-button>
        </div>
        </van-form>


    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }



    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        width: 55px;
        margin-left: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import namekey from "../../../utils/namekey";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';

    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'StationApply',
        components: {
            PicUploader,
        },
        data: function () {
            return {
                validator,
                saveLoading:false,
                clockSecond:0,
                showArea:false,
                showNamekey:false,
                areaList:{},
                namekeyList:{},
                areaValue:'',
                submitType:'',
                formData: {
                    id: 0,
                    type:1,
                    areas:'',
                    nprovince:'',
                    registstatus:'',
                    ncity:'',
                    ncounty:'',
                    province:'',
                    city:'',
                    county:'',
                    certificatepic:[] // [{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"},{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"}],
                },
            }
        },
        filters: {},
        mounted() {
            let that = this;
          document.title="备案申请"
          // console.log(area)
            that.areaList = area;
            that.namekeyList = namekey;
            that.formData.id = this.$route.query.id||0;
            if(!this.$route.query.new){
                that.fetch();
            }
        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        methods: {
            onQuestion(){
                console.log('onQuestion')
            },
            onNamekeyConfirm(values) {
                console.log(values);
                this.formData.namekey = values[2].code;
                this.formData.nprovince = values[0].name;
                this.formData.ncity = values[1].name;
                this.formData.ncounty = values[2].name;
                this.showNamekey = false;
            },
            onAreaConfirm(values) {
                console.log(values);
                this.formData.area = values[2].code;
                this.formData.province = values[0].name;
                this.formData.city = values[1].name;
                this.formData.county = values[2].name;
                this.showArea = false;
            },
            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);

                let that = this;
                console.log(that.formData)
                that.formValidate = true;
                for (let field in that.formData) {

                    if (that.formData.certificatepic.length != 2) {
                        Toast('请上传身份证正反面');
                        return
                    }
                    if (!this.formData.area) {
                        Toast('请选择地区');
                        return
                    }
                    if (!this.formData.namekey) {
                        Toast('请选择');
                        return
                    }
                }
                that.saveLoading = true;

                that.$api.post('/api/danwei/apply', that.formData, (res) => {
                    that.saveLoading = false;
                    rbLink({
                        name:'CertDanweiResult',
                    },'replace')
                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })
            },
            save(values){
                this.submitType = 'save';
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },
            fetch(){
                let that = this;
                that.$api.post('/api/danwei/detail', {
                }, (res) => {
                    if(res.data.id>0){
                        that.formData = res.data;
                    }
                }, (res) => {
//                    Toast.fail(res.msg);
                })
            },

            getCode() {
                let that = this;
                if (that.clockSecond > 0) {
                    return;
                }
                if (!that.formData.phone) {
                    Toast('请输入手机号')
                    return;
                }
                /*if (!that.formData.code) {
                    Toast('请输入验证码')
                    return;
                }*/
                that.$api.get('/api/index/phonecode', {phone: that.formData.phone}, (res) => {
                    Toast(res.msg);
                })

                that.clockSecond = 60;

                var t = setInterval(function () {
                    if (that.clockSecond > 0) {
                        that.clockSecond = that.clockSecond - 1;
                    } else {
                        clearInterval(t);
                    }
                }, 1000)
            }

        }
    }
</script>



// WEBPACK FOOTER //
// CertDanweiApply.vue?6a8733aa